import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Phone } from '../../tile/tile';

@Component({
  selector: 'app-modal-phone',
  templateUrl: './modal-phone.component.html',
  styleUrls: ['./modal-phone.component.scss'],
})
export class ModalPhoneComponent implements OnInit {
  @Input() phones: Map<string, Phone>;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    // this.phones.get("number1").phoneNumber
  }
}
